import { getKyivDateKey } from './getKyivDateParts'

const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/
const UNDERSCORE_DATE_PATTERN = /^(\d{4})_(\d{2})_(\d{2})$/

const isValidIsoParts = (year, month, day) => {
  const y = Number(year)
  const m = Number(month)
  const d = Number(day)

  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) {
    return false
  }

  if (m < 1 || m > 12 || d < 1 || d > 31) {
    return false
  }

  const date = new Date(Date.UTC(y, m - 1, d))

  return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d
}

export const normalizeDateInput = (value) => {
  if (value == null || value === '') {
    return null
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()

    if (!trimmed) {
      return null
    }

    const isoMatch = trimmed.match(ISO_DATE_PATTERN)

    if (isoMatch && isValidIsoParts(isoMatch[1], isoMatch[2], isoMatch[3])) {
      return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`
    }

    const underscoreMatch = trimmed.match(UNDERSCORE_DATE_PATTERN)

    if (underscoreMatch && isValidIsoParts(underscoreMatch[1], underscoreMatch[2], underscoreMatch[3])) {
      return `${underscoreMatch[1]}-${underscoreMatch[2]}-${underscoreMatch[3]}`
    }

    const dotMatch = trimmed.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)

    if (dotMatch && isValidIsoParts(dotMatch[3], dotMatch[2], dotMatch[1])) {
      return `${dotMatch[3]}-${dotMatch[2]}-${dotMatch[1]}`
    }

    const dotShortYearMatch = trimmed.match(/^(\d{2})\.(\d{2})\.(\d{2})$/)

    if (dotShortYearMatch) {
      const contextYear = Number(getKyivDateKey().split('-')[0])
      const yearSuffix = Number(dotShortYearMatch[3])
      const century = Math.floor(contextYear / 100) * 100
      let year = century + yearSuffix

      if (year > contextYear + 5) {
        year -= 100
      }

      if (isValidIsoParts(year, dotShortYearMatch[2], dotShortYearMatch[1])) {
        return `${year}-${dotShortYearMatch[2]}-${dotShortYearMatch[1]}`
      }
    }

    const dotDayMonthMatch = trimmed.match(/^(\d{2})\.(\d{2})$/)

    if (dotDayMonthMatch) {
      const contextYear = Number(getKyivDateKey().split('-')[0])

      if (isValidIsoParts(contextYear, dotDayMonthMatch[2], dotDayMonthMatch[1])) {
        return `${contextYear}-${dotDayMonthMatch[2]}-${dotDayMonthMatch[1]}`
      }
    }

    return null
  }

  if (typeof value === 'object') {
    if (typeof value.seconds === 'number') {
      return getKyivDateKey(new Date(value.seconds * 1000))
    }

    if (typeof value.toDate === 'function') {
      return getKyivDateKey(value.toDate())
    }
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return getKyivDateKey(value)
  }

  return null
}

export default normalizeDateInput
